export default __webpack_public_path__ + "static/media/lifeVision.62fe12fe.jpeg";